/**
 * Created by Marvin on 17.04.17.
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import DataProvider from '@wikom/wikom-data';
import findInObject from '@wikom/find-in-object';
import Symbol from '@wikom/react-symbol';
import { useRoute } from '@app/router';
import LoginDetails from './LoginDetails';
import Navigation from './Navigation';
var HeaderLoading = (React.createElement("div", { className: "header" },
    React.createElement("div", { className: "container" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-sm-3 col-md-2" },
                React.createElement("a", { href: "/", className: "logo" },
                    React.createElement("img", { src: "/images/logo_neu.png", width: "200", height: "100", alt: "LWK Rheinland-Pfalz" }))),
            React.createElement("div", { className: "col-sm-5 col-md-5" },
                React.createElement("h1", { className: "header-pagetitle" }, "WeinInformationsPortal (WIP)")))),
    React.createElement("nav", { className: "navbar navbar-inverse navbar--loading" },
        React.createElement("div", { className: "text-center" },
            React.createElement(Symbol, { symbol: "cog", spinning: true }),
            " Ihre Daten werden geladen..."))));
export var Header = function (_a) {
    var user = _a.user, props = __rest(_a, ["user"]);
    return (React.createElement("div", { className: "header" },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-sm-3 col-md-2" },
                    React.createElement("a", { href: "/", className: "logo" },
                        React.createElement("img", { src: "/images/logo_neu.png", width: "200", height: "100", alt: "LWK Rheinland-Pfalz" }))),
                React.createElement("div", { className: "col-sm-5 col-md-5" },
                    React.createElement("h1", { className: "header-pagetitle" }, "WeinInformationsPortal (WIP)")),
                React.createElement("div", { className: "col-sm-4 col-md-5" },
                    React.createElement(LoginDetails, { user: user })))),
        React.createElement(Navigation, { user: user, betrieb: findInObject('betrieb.betriebsnr', user) })));
};
export var HeaderWrapper = function () {
    var ROUTE = useRoute();
    return (React.createElement(DataProvider, { loading: HeaderLoading, name: "user", dataProp: "user", url: ROUTE.API.USER(), onlyLoaded: true },
        React.createElement(Header, null)));
};
export default HeaderWrapper;
